import React from 'react';
import PropTypes from 'prop-types';
import { RuSecondaryButton } from '@silverrailtech/srtlibrary';
import { Grid } from '@mui/material';

import logoImage from '../images/maintenance.svg';
import Header from '../components/Header/Header';

import {
	ButtonStyled,
	MaintenanceContent,
	ContentWrapper,
	TitleStyled,
} from './MaintenanceStyled';

const GenericErrorPage = ({ title, paragraphs, button, iconClassName }) => (
	<>
		<Header />
		<ContentWrapper>
			<Grid container>
				<Grid item xs={12} md={12}>
					<TitleStyled>{title}</TitleStyled>
				</Grid>

				<Grid item xs={12} md={12}>
					<MaintenanceContent>
						<div className="text-wrapper">
							{paragraphs?.map((text, i) => (
								<p key={i}>{text}</p>
							))}
							{button && (
								<ButtonStyled>
									<a href="/">
										<RuSecondaryButton
											color="neutral_1"
											aria-label="try again"
											fullWidth
										>
											Try again
										</RuSecondaryButton>
									</a>
								</ButtonStyled>
							)}
						</div>
						<div className={`icon-wrapper ${iconClassName}`}>
							<span>
								<img alt="maintenance" src={logoImage} />
							</span>
						</div>
					</MaintenanceContent>
				</Grid>
			</Grid>
		</ContentWrapper>
	</>
);

GenericErrorPage.propTypes = {
	title: PropTypes.string.isRequired,
	paragraphs: PropTypes.array.isRequired,
	button: PropTypes.bool,
	iconClassName: PropTypes.string,
};

export default GenericErrorPage;
